export const MANUAL_ACTIONS_SUBSCRIPTION_SETTINGS_FILTERS =
  'MANUAL_ACTIONS_SUBSCRIPTION_SETTINGS_FILTERS';
